
import React from 'react';
import { Route } from 'react-router-dom';
import NotFound from '@/pages/errors/404';
import Forbidden from '@/pages/errors/403';

export const getErrorRoutes = () => [
  <Route key="forbidden" path="/403" element={<Forbidden />} />,
  <Route key="not-found" path="*" element={<NotFound />} />
];
